// src/components/legal/AccountDeletion.js
import React from 'react';

const AccountDeletion = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-12">
            <div className="container mx-auto px-6 lg:px-20">
                <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                        계정 삭제 안내
                    </h1>

                    <div className="prose max-w-none">
                        <h2 className="text-xl font-semibold text-gray-800 mb-4">
                            앱 내에서 계정 삭제하기
                        </h2>

                        <div className="bg-sage-50 p-6 rounded-lg mb-6">
                            <p className="text-gray-700 mb-4">
                                <strong>Mind Wellness 앱</strong>에서 직접 계정을 삭제할 수 있습니다:
                            </p>
                            <ol className="list-decimal ml-6 space-y-2 text-gray-700">
                                <li>Mind Wellness 앱을 실행합니다</li>
                                <li>하단 메뉴에서 <strong>"프로필"</strong>을 선택합니다</li>
                                <li><strong>"설정"</strong> 메뉴를 터치합니다</li>
                                <li><strong>"계정 삭제"</strong>를 선택합니다</li>
                                <li>안내에 따라 삭제를 진행합니다</li>
                            </ol>
                        </div>

                        <h2 className="text-xl font-semibold text-gray-800 mb-4">
                            계정 삭제 시 처리되는 데이터
                        </h2>

                        <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-6">
                            <li>개인 프로필 정보</li>
                            <li>감정 기록 및 분석 데이터</li>
                            <li>AI 친구와의 대화 기록</li>
                            <li>활동 기록 및 성취 데이터</li>
                            <li>설정 및 환경설정 정보</li>
                        </ul>

                        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                            <div className="flex">
                                <div className="ml-3">
                                    <p className="text-sm text-yellow-700">
                                        <strong>주의:</strong> 계정 삭제 후에는 모든 데이터가 영구적으로 삭제되며 복구할 수 없습니다.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <h2 className="text-xl font-semibold text-gray-800 mb-4">
                            문의 및 지원
                        </h2>

                        <p className="text-gray-700 mb-4">
                            계정 삭제와 관련하여 문의사항이 있으시면 아래 연락처로 문의해 주세요:
                        </p>

                        <div className="bg-gray-50 p-4 rounded-lg">
                            <p className="text-gray-700">
                                <strong>이메일:</strong> mind-wellness@naver.com<br/>
                                <strong>회사명:</strong> 마인드월드(MindWorld)<br/>
                                <strong>개인정보보호책임자:</strong> 윤우재
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountDeletion;